





import Vue from 'vue';
import BlockTypeSettings from '@headlines/types/block/21-30/blockType26';
import AdFormBanner from '@ads/components/adForm/AdFormBanner.vue';

const defaultSettings = {
  component: 'adFormBanner',
  adType: 'mobile',
  data: {},
};

interface Computed {
  getSettings: BlockTypeSettings;
}

interface Props {
  settings: BlockTypeSettings;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    AdFormBanner,
  },
  computed: {
    getSettings() {
      return { ...defaultSettings, ...this.settings };
    },
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
});
